export default "<div class=\"toggle-button-group\">\n  <ng-content></ng-content>\n</div>\n"